import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #f5f5f5;
`;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }
  @media screen and (min-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    padding: 20px 0;
    font-size: 1.4em;
    position: relative;

    .move-btn {
      position: absolute;
      width: 1.5%;
      height: 100%;
      top: 0;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`;

export const AdviceWriteBtn = styled.div`
  position: fixed;
  bottom: 75px;
  right: 40px;
  text-align: center;

  & img {
    width: 68px;
    height: 68px;
    cursor: pointer;
  }

  & p {
    font-size: 1em;
    color: #2a3a4b;
    font-family: "spoqa700";
  }
  @media screen and (min-width: 1050px) {
    & img {
      width: 88px;
      height: 88px;
    }
    & p {
      font-size: 1.2em;
    }
  }
`;

export const NoListPage = styled.div`
  width: 100%;
  height: calc(100vh - 10vh);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  .nolist-text {
    font-size: 1.75em;
    color: #2a3a4b;
    width: 100%;
  }
  .nolist-text2 {
    position: relative;
    font-size: 1em;
    color: #979797;
    margin-top: 17px;

    & img {
      position: relative;
      top: 3.5px;
      right: 5px;
    }
  }

  @media screen and (min-width: 1050px) {
    .nolist-text {
      font-size: 2em;
    }
    .nolist-text2 {
      position: relative;
      font-size: 1.25em;
      color: #979797;
      margin-top: 22px;

      & img {
        position: relative;
        top: 2px;
        right: 5px;
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const AdviceList = styled.div`
  width: 100%;
  .wrapper div {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    font-weight: bold;
    flex-direction: column;
    margin-bottom: 100px;
    .spnas span {
      margin-top: 10px;
      font-size: 18px;
      color: #979797;
      font-weight: normal;
    }
  }
`;

export const AdviceListItem = styled.div`
  width: 100%;
  padding-top: 30px;
  background: #fff;

  margin-bottom: 20px;
  .advice-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;

    & .advice-name {
      font-family: "spoqa700";
      /* font-size: 0.75em; */
      font-size: 16px;
      color: #2a3a4b;
    }
    & .advice-date {
      /* font-size: 0.75em; */
      font-size: 18px;
      color: #656565;
    }
  }

  .advice-title {
    padding: 0 40px;
    font-size: 1em;
    color: #2a3a4b;
    margin-top: 15px;
  }

  .advice-content {
    padding: 0 40px;
    font-size: 0.88em;
    color: #636363;
    margin-top: 8px;
  }
  .advice-img {
    padding: 0 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0px 23px 0px;
    flex-wrap: wrap;
    & .advice-img-item {
      width: 10%;
      margin-left: 3px;

      & img {
        width: 100%;
      }

      &:first-child {
        margin-left: 0px;
      }
    }
  }

  .detail-img {
    padding: 0 40px;
    width: 100%;
    margin-top: 10px;

    & .detail-img-item {
      width: 100%;
      margin-left: 3px;

      & img {
        width: 100%;
      }
    }
  }

  .advice-comment.detail {
    border-bottom: none;
    margin-bottom: 60px;
    margin: 70px 0px;
  }

  .advice-comment {
    width: 100%;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    padding: 11px 40px 23px 40px;

    .replycon {
      /* background-color: orange; */
      position: relative;
      right: -30px;
    }

    .advice-wrapper {
      /* background-color: lavender; */
      margin: 10px 0px;
      padding: 20px 20px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
    }

    .wrapper {
      display: flex;
    }

    & .advice-comment-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      & .advice-comment-user {
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;

        & img {
          width: 100%;
        }
      }

      & .advice-comment-name {
        font-size: 0.75em;
      }
    }
    .advice-comment-text {
      font-size: 0.75em;
      padding-left: 29px;
      margin-top: 9px;
      color: #636363;

      & span {
        font-size: 0.63em;
        cursor: pointer;
        color: #2a3a4b;
      }
    }
  }

  @media screen and (min-width: 1050px) {
    .advice-top {
      & .advice-name {
        font-size: 1em;
      }
      & .advice-date {
        font-size: 1em;
      }
    }
    .advice-title {
      font-size: 1.2em;
      margin-top: 18px;
    }

    .advice-content {
      font-size: 1.1em;
      margin-top: 12px;
    }

    .advice-comment {
      width: 100%;
      padding: 11px 40px 23px 40px;

      & .advice-comment-info {
        & .advice-comment-user {
          width: 26px;
          margin-right: 7px;

          & img {
            width: 100%;
          }
        }

        & .advice-comment-name {
          font-size: 0.88em;
        }
      }
      .advice-comment-text {
        font-size: 0.81em;
        padding-left: 33px;
        margin-top: 9px;

        & span {
          font-size: 0.75em;
        }
      }
    }
  }
`;

// 상담 작성 페이지

export const PageTop2 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 40px;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  .left-arrow {
    cursor: pointer;
    & img {
      width: 100%;
    }
  }
  .write-submit {
    border: none;
    background-color: #73972c;
    color: #fff;
    padding: 7px 18px;
    font-size: 0.88em;
    border-radius: 5px;
    cursor: pointer;
  }
  .delete-submit {
    border: none;
    background-color: #dddddd;
    color: #656565;
    padding: 7px 18px;
    font-size: 0.88em;
    border-radius: 5px;
    cursor: pointer;
  }

  @media screen and (min-width: 1050px) {
    .left-arrow {
      width: 35px;
    }
    .write-submit {
      font-size: 1.18em;
    }
    .delete-submit {
      font-size: 1.18em;
    }
  }
`;

export const WriteForm = styled.div`
  background-color: #fff;
  padding: 20px 0px;

  .writeform-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;

    & .writeform-name {
      font-family: "spoqa700";
      /* font-size: 0.75em; */
      font-size: 16px;

      color: #2a3a4b;
    }
    & .writeform-date {
      font-size: 0.75em;
      color: #656565;
    }
  }
  .writeform-box {
    padding: 0 40px;
    p {
      font-size: 0.88em;
      color: #636363;
      margin-top: 15px;
    }
    & input {
      width: 100%;
      height: 38px;
      border: 1px solid #dddddd;
      padding: 10px 8px;
      font-size: 0.88em;
      margin-top: 5px;
      background: #f7f7f7;
    }
    & textarea {
      width: 100%;
      height: 78px;
      border: 1px solid #dddddd;
      padding: 10px 8px;
      font-size: 0.88em;
      margin-top: 5px;
      background: #f7f7f7;
    }

    input[type="checkbox"] {
      appearance: none;
      width: 14px;
      height: 14px;
      border: 1.125px solid #dddddd;
      margin-right: 5px;
      position: relative;
      top: 2px;
      margin-top: 14px;
      background: #fff;
      padding: 0px;

      &:checked {
        border-color: transparent;
        background-image: url("./img/checked.svg");
        background-size: 100% 100%;
        background-position: 50%;
        background-repeat: no-repeat;
        background-color: #73972c;
      }
    }
    label {
      font-size: 0.88em;
      font-family: "spoqa500";
    }
  }

  @media screen and (min-width: 1050px) {
    .writeform-top {
      & .writeform-name {
        font-size: 1em;
      }
      & .writeform-date {
        font-size: 1em;
      }
    }
    .writeform-box {
      padding: 0 40px;
      p {
        font-size: 1em;
      }
      & input {
        width: 100%;
        height: 44px;
        border: 1px solid #dddddd;
        padding: 10px 8px;
        font-size: 0.88em;
        margin-top: 5px;
        background: #f7f7f7;
      }
      & textarea {
        width: 100%;
        height: 88px;
        border: 1px solid #dddddd;
        padding: 10px 8px;
        font-size: 0.88em;
        margin-top: 5px;
        background: #f7f7f7;
      }

      & input[type="checkbox"] {
        appearance: none;
        width: 17px;
        height: 17px;
        border: 1.125px solid #dddddd;
        margin-right: 5px;
        position: relative;
        top: 3px;
        margin-top: 14px;
        background: #fff;
        padding: 0px;

        &:checked {
          border-color: transparent;
          background-image: url("./img/checked.svg");
          background-size: 100% 100%;
          background-position: 50%;
          background-repeat: no-repeat;
          background-color: #73972c;
        }
      }
      label {
        font-size: 1em;
        font-family: "spoqa500";
      }
    }
  }
`;

export const ImageUpLoadBox = styled.div`
  width: 100%;
  padding: 20px 40px 32px 40px;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;

  .content-tit {
    font-size: 1em;
    color: #2a3a4b;
    font-family: "spoqa700";
  }

  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
    }
  }
`;

export const ImageUpload = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 16px;

  input[type="file"] {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  label {
    cursor: pointer;
    & .camera-btn {
      width: 60px;
      height: 60px;
      border-radius: 3px;
      background-color: #dddddd;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      & .camera-img {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60%;
      }

      & .total-img {
        font-size: 0.69em;
        font-family: "spoqa500";
        height: 40%;
      }
    }
  }
  @media screen and (min-width: 1050px) {
    label {
      & .camera-btn {
        width: 100px;
        height: 100px;
        & .camera-img {
          width: 100%;
          height: 60%;

          & img {
            width: 50%;
          }
        }

        & .total-img {
          font-size: 1.2em;
          font-family: "spoqa500";
          height: 40%;
        }
      }
    }
  }
`;

export const PreviewIamge = styled.div`
  width: 60px;
  height: 60px;
  margin-left: 10px;
  & img {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 1050px) {
    width: 100px;
    height: 100px;
  }
`;

// 상담 detail 페이지
export const AdviceComment = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0px -2px 6px rgba(199, 199, 199, 0.25);
  background-color: #fff;
  padding: 15px 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  input {
    width: 95%;
    height: 35px;
    border: none;
    background: #f7f7f7;
    font-size: 0.75em;
    padding: 10px 12px;
    border-radius: 5px;
  }
  img {
    width: 18px;
    margin-left: 7px;
    cursor: pointer;
  }

  @media screen and (min-width: 1050px) {
    input {
      width: 95%;
      height: 45px;
      border: none;
      background: #f7f7f7;
      font-size: 0.88em;
      padding: 10px 12px;
      border-radius: 5px;
    }
    img {
      width: 28px;
      margin-left: 7px;
      cursor: pointer;
    }
  }
`;

export const Goback = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  /* background-color: #fff; */
  flex-direction: column;
  div :first-child {
    width: 300px;
    height: 100px;
    font-size: 40px;
    display: flex;
    justify-content: center;

    align-items: center;
  }

  span {
    border-radius: 30px;
    background-color: #6dc0f2;
    width: 300px;
    height: 100px;
    margin-top: 10px;
    font-size: 35px;
    color: #fff;
    display: flex;
    justify-content: center;

    align-items: center;
  }
`;

export const Dummy = styled.div`
  display: flex;
  border-radius: 30px;
  flex-direction: column;
  background-color: #ffff;
  width: 500px;
  height: 400px;
  justify-content: center;
  align-items: center;
`;
